import { Badge, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import React from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

import { ParentChildrenDto } from "../../../../interfaces";

type TProps = {
  title: string;
  children: ParentChildrenDto[];
  show: boolean;
  onCloseClick: (event: any) => void;
};
export const ParentChildrenModal: React.FC<TProps> = ({
  title,
  children,
  show,
  onCloseClick,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region internal states

  //#endregion

  //#endregion

  //#region handlers
  const onClose = () => {
    onCloseClick(!show);
  };

  //#endregion

  return (
    <React.Fragment>
      <Modal
        size="lg"
        id="subjects"
        isOpen={show}
        toggle={() => {
          onClose();
        }}
        centered
      >
        <ModalHeader
          className="p-3"
          toggle={() => {
            onClose();
          }}
        >
          {t(title)} {`(${children.length})`}
        </ModalHeader>
        <ModalBody>
          <Row>
            {children.map((child: ParentChildrenDto, index: number) => (
              <Col lg={4} className="py-2">
                <Row>
                  <Col className="d-flex justify-content-center">
                    <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                      {child.profilePhoto != null ? (
                        <img
                          src={child.profilePhoto}
                          className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                          alt="user-profile"
                        />
                      ) : (
                        <div className="rounded-circle avatar-xl img-thumbnail user-profile-image">
                          <div className="avatar-title text-uppercase border rounded-circle bg-light text-primary">
                            {child?.name?.en
                              ? child?.name?.en.charAt(0) +
                                child?.name?.en
                                  .split(" ")
                                  .slice(-1)
                                  .toString()
                                  .charAt(0)
                              : "child".charAt(0) +
                                "child"
                                  .split(" ")
                                  .slice(-1)
                                  .toString()
                                  .charAt(0)}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-center">
                      <div className="team-content pt-2">
                        <h3 className="fs-16 mb-1">
                          {child?.name?.en
                            ? i18n.language === "ar"
                              ? child.name?.ar
                              : child.name?.en
                            : t("nameNotAvailable")}
                        </h3>
                      </div>
                      <div className="team-content pt-1">
                        <h4 className="fs-14 mb-1">
                          {child?.gender
                            ? t(child?.gender)
                            : t("genderNotAvailable")}
                        </h4>
                      </div>
                      <div className="team-content pt-1">
                        <h5 className="fs-14 mb-1">
                          +
                          {child?.phone?.countryCode + child?.phone.phoneNumber}
                        </h5>
                      </div>
                      <div className="team-content pt-1">
                        <h6 className="fs-12 mb-1">
                          {new Date(child.date).toLocaleDateString()}{" "}
                          {new Date(child.date).toLocaleTimeString()}
                        </h6>
                      </div>
                      <Badge color="danger">
                        {child.isDeleted ? "Deleted" : ""}
                      </Badge>
                    </div>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
